<template>
  <div data-qa="zava-footer" v-html="footerContent"></div>
</template>

<script>
import { getUrlLocale } from '@/helpers/url'
export default {
  name: 'ZavaFooter',
  data () {
    return {
      footerContent: ''
    }
  },
  beforeMount () {
    const locale = getUrlLocale()
    this.setFooter(locale)
  },
  methods: {
    async getFooter (locale) {
      try {
        const res = await fetch('/' + locale + '/footer.html?name=porta')
        return res.text()
      } catch (error) {
        if (window.newrelic) {
          window.newrelic.noticeError(error)
        }
      }
    },
    async setFooter (locale) {
      const res = await this.getFooter(locale)
      const parsed = new DOMParser().parseFromString(res, 'text/html')
      const parsedScript = parsed.querySelector('script')
      this.footerContent = parsed.querySelector('body').innerHTML

      if (parsedScript) {
        const scriptStr = parsedScript.innerText
        const script = document.createElement('script')

        parsedScript.remove()

        script.textContent = scriptStr

        await new Promise(resolve => {
          setTimeout(() => {
            document.querySelector('body').appendChild(script)
            resolve()
          }, 1)
        })
      }
    }
  }

}
</script>
